import { render } from "./GainConfigurationVersionsModal.vue?vue&type=template&id=15573d54&scoped=true&ts=true"
import script from "./GainConfigurationVersionsModal.vue?vue&type=script&lang=ts"
export * from "./GainConfigurationVersionsModal.vue?vue&type=script&lang=ts"

import "./GainConfigurationVersionsModal.vue?vue&type=style&index=0&id=15573d54&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15573d54"]])

export default __exports__